import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericResultModel } from 'src/app/sharedFeatures/models/generic-result.model';
import { BaseHttpServiceService } from 'src/app/sharedFeatures/services/base-http-service.service';
import { CurrentUserService } from 'src/app/sharedFeatures/services/current-user.service';
import { ProjectTaskLightViewModel } from '../models/projectTask-light-view-model.model';
import { ProjectTaskLookupSearchModel } from '../models/projectTask-lookup-search-model.model';
import { ProjectTaskSearchModel } from '../models/projectTask-search-model.model';
import { ProjectTaskViewModel } from '../models/projectTask-view-model.model';
import { ProjectTaskViewViewModel } from '../models/projectTask-view-view-model.model';
import { ProjectTaskLookupViewModel } from '../models/projectTask-lookup-view-model.model';
import { map } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ProjectTaskService extends BaseHttpServiceService {
  private controller: string = `${this.baseUrl}/ProjectTask`;

  constructor(
    http: HttpClient,
    translateService: TranslateService,
    currentUserService: CurrentUserService
  ) {
    super(http, translateService, currentUserService);
  }
  search(
    model: any
  ): Observable<GenericResultModel<ProjectTaskLightViewModel[]>> {
    let url: string = `${this.controller}/search`;
    return this.postData<GenericResultModel<ProjectTaskLightViewModel[]>>(
      url,
      model
    );
  }
  getListLookup(): Observable<ProjectTaskLookupViewModel[]> {
    let url: string = `${this.controller}/searchListLookup`;
    return this.postData<ProjectTaskLookupViewModel[]>(url, null);
  }
  getLookup(
    searchModel: ProjectTaskLookupSearchModel
  ): Observable<GenericResultModel<ProjectTaskLookupViewModel[]>> {
    let url: string = `${this.controller}/searchLookup`;
    return this.postData<GenericResultModel<ProjectTaskLookupViewModel[]>>(
      url,
      searchModel
    );
  }
  getById(id: any): Observable<ProjectTaskViewModel> {
    let url: string = `${this.controller}/get/${id}`;
    return this.getData<ProjectTaskViewModel>(url);
  }

  getViewById(id: any): Observable<ProjectTaskViewViewModel> {
    let url: string = `${this.controller}/details/${id}`;
    return this.getData<ProjectTaskViewViewModel>(url).pipe(
      map(task => {
        task.estimatedProgress = task.estimatedProgress ?? 0; // Ensure it’s not null
        return task;
      })
    );
  }

  add(model: ProjectTaskViewModel): Observable<ProjectTaskViewModel> {
    let url: string = `${this.controller}/add`;
    return this.postData<ProjectTaskViewModel>(url, model);
  }

  update(model: ProjectTaskViewModel): Observable<ProjectTaskViewModel> {
    let url: string = `${this.controller}/update`;
    return this.postData<ProjectTaskViewModel>(url, model);
  }

  delete(id: any): Observable<any> {
    let url: string = `${this.controller}/delete/${id}`;
    return this.postData<any>(url, null);
  }
}
